module.exports = __webpack_public_path__ + "static/media/B5.4211e70a.svg";